const errorResponseReturn = (error: any) =>
  typeof error?.response?.data?.message === 'object' ? error?.response?.data?.message?.[0] || '' : error?.response?.data?.message

export default errorResponseReturn
